module.exports = __webpack_public_path__ + "static/media/pb.168fcc3f.jpg";